import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Marketing.css";
import Button from "../../components/Button/Button";
import Dashboard from "./Dashboard";
import Accounts from "./Accounts";

// /Marketing muestra los dashboards; /Marketing/Accounts los proyectos y conexiones.
// La API redirige a /marketing/accounts después de conectar una red social
// (las rutas no distinguen mayúsculas).
export default function Marketing() {
    const location = useLocation();
    const navigate = useNavigate();
    const isAccounts = location.pathname.toLowerCase().startsWith("/marketing/accounts");

    return (
        <article className="container-home mk-page">
            <h1 className="title">
                MARKETING
                <hr />
            </h1>

            <div className="mk-tabs" role="tablist" aria-label="Submenu de marketing">
                <Button
                    variant="outline"
                    size="small"
                    role="tab"
                    selected={!isAccounts}
                    aria-selected={!isAccounts}
                    onClick={() => navigate("/Marketing")}
                >
                    Dashboards
                </Button>
                <Button
                    variant="outline"
                    size="small"
                    role="tab"
                    selected={isAccounts}
                    aria-selected={isAccounts}
                    onClick={() => navigate("/Marketing/Accounts")}
                >
                    Proyectos y conexiones
                </Button>
            </div>

            {isAccounts ? <Accounts /> : <Dashboard />}
        </article>
    );
}
